var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframe)?_c('iframe',{attrs:{"src":_vm.url,"seamless":"","allow":"camera *; microphone *; clipboard-read *; clipboard-write *; web-share *","name":"target"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }